export default __webpack_public_path__ + "static/media/letras-A-H.d9b8c1f3.svg";